import { Injectable } from '@angular/core';
import { LoggingConsole } from '../publishers';
import { LoggingApiPublisher } from '../publishers/logging-api.publisher';
import { ILoggingPublisher } from '../publishers/logging-publisher.interface';
import { RxdbLogLoggingPublisher } from '../publishers/logging-rxdb.publisher';

@Injectable()
export class LoggingPublishersService {
	private publishers: ILoggingPublisher[] = [];

	public constructor(
		private loggingRxdbPublisher: RxdbLogLoggingPublisher,
		private apiPublisher: LoggingApiPublisher
	) {
		this.buildPublishers();
	}

	public getPublishers(): ILoggingPublisher[] {
		return this.publishers;
	}

	private buildPublishers(): void {
		//  this.publishers.push(new LoggingLocalFiles());
		this.publishers.push(new LoggingConsole());
		this.publishers.push(this.loggingRxdbPublisher);
		//	this.publishers.push(this.apiPublisher);
	}
}
